<div class="lmo-frac" [ngStyle]="{ overflow: (onFracList$ | async) === true ? 'hidden' : 'auto' }">
  <div *ngIf="(onFracList$ | async) === false">
    <div class="title-wrap nav-background" *ngIf="currentFrac$ | async as currentFrac">
      <div class="title">
        <h2>
          <span
            *ngIf="currentFrac.percentBasedAutoOrdering"
            class="percent_glow"
            [class.percent_glow_warning]="(hasFCPOAllocations$ | async) === false"
            >%</span
          >
          <div class="flex flex-col">
            <div>
              <span class="text-white">{{ currentFrac | fracName }}</span>
              <span class="api-pill" *ngIf="currentFrac.createdByAPI">API</span>
              <span
                class="material-icons zip-not-available"
                *ngIf="isShaleApps && !currentFrac.zip"
                [matTooltip]="'Zip Code Not Added'"
              >
                info
              </span>
            </div>
            <div class="text-white font-normal text-sm">
              <span *ngIf="currentFrac.waitTime !== 0"
                >Est In & Out Time: {{ currentFrac.waitTime | minutesToHuman }}</span
              >
              <span *ngIf="currentFrac.waitTime === 0">Est In & Out Time: N/A</span>
            </div>
          </div>
        </h2>
      </div>
    </div>
  </div>
  <router-outlet></router-outlet>
</div>
